'use strict';

var React = require('react'),
    AboutSection = require('../organisms/AboutSection'),
    TabBar = require('../molecules/TabBar'),
    TabLink = require('../atoms/TabLink'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    ScreenSizeMixin = require('../mixins/ScreenSizeMixin'),
    AboutSectionGrid = require('../organisms/AboutSectionGrid'),
    AboutSectionCarousel = require('../organisms/AboutSectionCarousel'),
    { PropTypes } = React;

const zineTabs = [{
  title: 'Photography',
  cover: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/bc69ea56-c793-4302-a377-ea40dd6285a1.jpg',
  url: '/fotografia-magazine',
  previews: [
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/bb9ca7c4-565c-48f6-9cc5-8220785dfe0e.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/77aae748-dacc-41b0-bef4-d3badbc99f2a.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5d3a8577-ca6c-4c9b-8af6-994016f1b28e.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/f7426f46-555c-4ebe-b060-59ef51cdbfd0.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/551572c2-cb83-4216-bb6f-c6266ed6dda0.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/3be32c7c-431d-4360-bee8-fcf0dccbb485.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/242c15d6-bb22-4b16-8b8f-517d365cdf78.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/6268f1e5-1fc8-4905-9542-f1ae6adcd40d.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/eb281f73-d609-4e47-9342-7de3b4083dab.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/e516ee96-a2c6-4304-939d-69f7ccbefab7.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/98658acd-6484-40c3-ad89-04e7648da196.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/4519a07d-e9fa-44f6-863e-a6be63bed68e.jpg'
  ]
}, {
  title: 'Art',
  cover: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/eecf1aeb-4830-4cb7-982c-774f0ef25c33.jpg',
  url: '/uncollected',
  previews: [
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5a1f7319-7521-47e7-a792-41b29629efa9.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/54940b80-12cd-4108-90b7-197d1cf00d85.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/8cb29bd2-d759-4e7a-8f6d-84c6a688f7b5.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/05299dbd-d442-484a-9b7e-e0e88205bf2f.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/c4b30059-be35-4ea2-9d29-afd90479e8b6.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/c3527dc6-d24a-49f6-8021-3c1965337691.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/d59366a0-feaa-4d01-8689-201cd21c3e72.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/a9095a72-3900-4103-a4ca-38a367bfcd8e.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/b1542e51-7557-460b-870a-987554a11609.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/9170f288-b9fd-4303-abd3-93e85507ddfa.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5831efcf-bc6e-4c66-b370-2033d5e0cd63.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/f87fb207-efbc-4ea0-9e07-7d78ba131a44.jpg',
  ]
}, {
  title: 'Film',
  cover: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/5d9f99cb-63da-40b5-ac27-3bdef5b40751.jpg',
  url: '/movie-stills',
  previews: [
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/58a2b34f-eae7-45ef-8844-d445ede7e64d.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/9a7b45b2-7d2b-44cf-931a-7d842aa46765.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/63641ee8-2727-44d0-9a7a-87005719195e.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/0934153a-ad90-41be-ad64-b7be778f297c.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/2d09ccd3-7f03-4140-a200-f52baf5ac5c1.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/084b2f34-509a-4de7-81e8-a4c2a90636dc.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/989c9eb4-6b0c-4e45-be61-1e0ea3e64963.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/daf9fc2d-21f3-4457-9818-17b937161865.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/26fc97d6-d28a-4d03-89dc-833b65b16398.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/96e63175-d091-49c8-a664-6d1faaec57eb.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/05fbaa96-fd62-4ef2-9e4b-bbf9930e728a.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5623a5e7-1b7c-4b02-94e3-f7d49fa0a7f6.jpg'
  ]
}, {
  title: 'Music',
  cover: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/11cd2e80-c8d6-4122-be49-266e4086e63b.jpg',
  url: '/music-photography',
  previews: [
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/f78ebc30-2c58-47aa-8a67-b482829e07c3.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/8d6178f3-cb72-4694-9400-5cbfd93ecf3c.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/649da9dc-159b-4261-97c9-6110c6e8ffff.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/d10b2eb2-ae20-47fe-bef0-be586ad8b2c8.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/d337e766-02b8-4a4b-b84a-a1c05aa9d5fd.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/11e65697-130d-477a-aa90-36652e9e9b7d.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/72f4d28b-36d8-4ee9-8999-dcfba37a6137.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/5152a814-190e-464b-96ce-121b960c9d77.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/bf9e669c-b119-449b-b855-cac4e522a18e.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/41e45adb-8bb5-4da8-9aa9-f2818f1eb813.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/38fce6eb-10ed-466b-8dd0-d63cac33adad.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/57d126e4-04ef-4f55-9a94-80539580bd1c.jpg'
  ]
}, {
  title: 'Design',
  cover: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/05b84a37-85b7-4f6b-b9c3-09e0d6901ec0.jpg',
  url: '/digital-imagery',
  previews: [
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/fc17923c-24dd-45e5-95d0-53467ae61d80.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/a0a01621-980b-4133-9404-359ad5e27336.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/67bcfc4b-b2e5-48cd-ac7b-1c45c51fdc81.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/88991a75-a216-43d2-9690-315a98208d3c.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/83e8a3b5-59c9-4cba-b7d3-f78adde05d28.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/89cf28d8-571f-4887-a226-472e04b06feb.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/732ab831-7184-4782-8c4a-e3074c178f4b.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/37018538-adff-4aa2-b7d2-6145804f3db9.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/946147ba-2a33-4ec6-b298-173494efcd56.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/b5c4b678-025d-49f1-8d0d-f2f5ac8a0d14.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/1c9daac4-2f94-4b60-8dec-4167d78520e1.jpg',
    '//stampsy-eu-1.s3.amazonaws.com/uploads/02/21/2015/d939fe1d-131f-41c8-b96d-ee3fd0697d9d.jpg'
  ]
}];

var AboutZinesSection = React.createClass({
  mixins: [ClassNameMixin, ScreenSizeMixin, PureRenderMixin],

  propTypes: {
    layout: PropTypes.any.isRequired,
    active: PropTypes.bool.isRequired
  },

  getInitialState() {
    return {
      activeZineTabIndex: 0
    };
  },

  getCSSModifiers() {
    return {
      inactive: !this.props.active
    };
  },

  render() {
    const { isMobile } = this.state;

    return (
      <AboutSection layout={this.props.layout}
                    active={this.props.active}
                    title='Use collections to make connections.'
                    subtitle='Add your creation to relevant collections curated by people like you and get your work instantly noticed. Or start a collection of your own and use it however you like.'
                    backgroundColor='#1B39A8'
                    color='white'>
        <div className={this.getClassName()}>
          {isMobile ?
            this.renderMobileCarousel() :
            this.renderDesktopCarousel()
          }
        </div>
      </AboutSection>
    );
  },

  renderMobileCarousel() {
    const { active } = this.props;
    return (
      <AboutSectionCarousel type='zines'
                            active={active}
                            hideScrollbars>
        {zineTabs.map((zineTab, index) =>
          <AboutSectionCarousel.Image imageUrl={zineTab.cover}
                                      imageSize={{ width: 320, height: 430 }}
                                      key={index} />
        )}
      </AboutSectionCarousel>
    );
  },

  renderDesktopCarousel() {
    const { active } = this.props;
    const { activeZineTabIndex } = this.state;

    return (
      <div>
        <div className='AboutZinesSection-tabs'>
          <TabBar context='AboutPage'>
            {zineTabs.map((zineTab, index) =>
              <TabLink key={index}
                       onClick={this.handleZineTabClick.bind(this, index)}
                       active={index === activeZineTabIndex}>
                {zineTab.title}
              </TabLink>
            )}
          </TabBar>
        </div>

        {zineTabs.map((zineTab, index) =>
          <AboutSectionCarousel type='zines'
                                hidden={activeZineTabIndex !== index}
                                key={index}
                                active={active}>
            <AboutSectionGrid imageUrls={zineTab.previews.slice(0, 4)}
                              imageSize={{ width: 132, height: 178 }}
                              type='zinesLeft'
                              active={active} />
            <a href={zineTab.url} target="_blank">
              <AboutSectionCarousel.Image imageUrl={zineTab.cover}
                                        imageSize={{ width: 320, height: 430 }} />
            </a>
            <AboutSectionGrid imageUrls={zineTab.previews.slice(4, 8)}
                              imageSize={{ width: 132, height: 178 }}
                              type='zinesRight'
                              active={active} />
          </AboutSectionCarousel>
        )}
      </div>
    );
  },

  handleZineTabClick(index) {
    this.setState({
      activeZineTabIndex: index
    });
  }
});

module.exports = AboutZinesSection;



/** WEBPACK FOOTER **
 ** ./organisms/AboutZinesSection.jsx
 **/